import React from 'react';
import Tooltip from 'js/components/elements/mui/Tooltip';
import type { TooltipProps } from '@mui/material/Tooltip';

interface TooltipWithTitleProps {
  title: string | React.ReactNode;
  description: string | React.ReactNode;
  children: React.ReactElement;
  placement?: TooltipProps['placement'];
  arrow?: boolean;
  rootStyle?: React.CSSProperties;
  muiTooltipProps?: Partial<TooltipProps>;
  theme?: 'dark' | 'light';
}

const TooltipContent: React.FC<{
  title: React.ReactNode;
  description: React.ReactNode;
}> = ({ title, description }) => (
  <div style={{ textAlign: 'center' }}>
    <div className="tooltip-title">{title}</div>
    <div className="tooltip-description">{description}</div>
  </div>
);

export function TooltipWithTitle({
  title,
  description,
  children,
  placement = 'top',
  arrow = false,
  rootStyle,
  muiTooltipProps = {},
  theme = 'dark',
}: TooltipWithTitleProps) {
  const tooltipContent = <TooltipContent title={title} description={description} />;
  return (
    <Tooltip
      tooltipTheme="general"
      mode={theme}
      title={tooltipContent}
      placement={placement}
      arrow={arrow}
      rootStyle={rootStyle}
      {...muiTooltipProps}
    >
      {children}
    </Tooltip>
  );
}
